import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
header.append( 'Access-Control-Allow-Origin', '*')

@Injectable({
  providedIn: 'root'
})


export class RequestconfigService {


  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;
  dateFormat = environment.dateFormat;
  Post(data: any): Observable<any> {

    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/add', data, { headers: header, observe: 'response' })
  }
  GetById(request: number, requesttypeid: number): Observable<any> {

    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/GetbyId?requestid=' + request + '&&requesttypeid=' + requesttypeid, { headers: header, observe: 'response' })
  }
  Put(data: any): Observable<any> {

    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/update', data, { headers: header, observe: 'response' })
  }
  DownloadFile(documentId: number, dbName: string, formConfigId: number, fileName: string): Observable<any> {

    return this.httpClient.get<any>(this.baseUrl + 'api/RequestConfigApi/DownloadFile?documentId=' + documentId + ' &&dbName=' + dbName + '&&formConfigId=' + formConfigId + '&&fileName=' + fileName);

  }
  conversionrequestfileupdate(data:any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/conversionrequestfileupdate', data, { headers: header, observe: 'response' })
  }
 /* ReplaceConversionFile(formdata: FormData){
    return this.httpClient.post(this.baseUrl + 'api/RequestConfigApi/ReplaceConversionFile', formdata, { observe: 'response' })
  }*/
  PostFile(formdata: FormData) {
    return this.httpClient.post(this.baseUrl + 'api/RequestConfigApi/addrequestrelatedfile', formdata, { observe: 'response' })
  }
  DownloadFileRequest(database: string, requesttype: string, requestdetailid: number, type: string, fileName: string): Observable<any> {

    return this.httpClient.get<any>(this.baseUrl + 'api/RequestConfigApi/DownloadFileRequest?requesttype=' + requesttype + '&&requestid=' + requestdetailid + ' &&dbname=' + database + '&&fileName=' + fileName + '&&type=' + type);
  }
  GetRequestType(): Observable<any> {

    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/GetRequestTypeData', { headers: header, observe: 'response' })
  }
  GetServerDate(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CommonFunctionApi/GetServerDate/' + this.dateFormat);
  }
  DownloadFormFile(fileData: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/DownloadFormFile', fileData, { headers: header, observe: 'response' });
  }
  DownloadFormFiletabopen(fileData: any): Observable<Blob> {
    
    return this.httpClient.post(this.baseUrl + 'api/RequestConfigApi/DownloadFormFiletabopen', fileData, {
      responseType: 'blob'     
    });
  }  

  DownloadFileRequestWithSpecialCharacters(requestData: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/DownloadFileRequestWithSpecialCharacters', requestData, { headers: header, observe: 'response' });
  }
  DownloadFileRequestWithSpecialCharactersasZIP(requestData: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/DownloadFileRequestWithSpecialCharactersasZIP', requestData, { headers: header, observe: 'response' });
  }

  GetArbitrationData(requestData) {
    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/GetArbitrationData', requestData, { headers: header, observe: 'response' });
  }
  DownloadFormFileAsZip(fileData: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/DownloadFormFileAsZip', fileData, { headers: header, observe: 'response' });
  }
  checkConversionExist(data: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/CheckConversionExist', data, { headers: header, observe: 'response' });
  }
  DownloadNonCaseLawFormFile(fileData: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestConfigApi/DownloadNonCaseLawFormFile', fileData, { headers: header, observe: 'response' });
  }
}
